<template>
    <v-container fluid>
        <v-row class="mt-6 ml-6">
            <v-text-field v-model="search_text" placeholder="搜尋" single-line="" class="input_600 ml-3" outlined></v-text-field>
            <!-- <v-btn large color="success" class="ml-3 mt-1" style="height: 46px; font-size: 18px;">搜尋</v-btn> -->
            <v-spacer></v-spacer>
            <v-btn v-if="mode==0 && ['1', '2'].indexOf(account_type)!=-1" to="/create_question" large color="primary" class="ml-3 mt-1 mr-3" style="height: 46px; font-size: 18px;">建立問卷</v-btn>
            <v-btn v-if="mode==1" :to="'/question_assign?s='+survey_id+'&c=1'" large color="primary" class="ml-3 mt-1" style="height: 46px; font-size: 18px;">產生子問卷</v-btn>
        </v-row>

        <!-- {{table_data}} -->

        <v-row class="mt-6 ml-6">
            <v-col cols="12" sm="12">
                <v-data-table :search="search_text" :headers="headers" :items="table_data" class="elevation-1">
                    <template v-slot:item.index="{item}">
                        {{table_data.findIndex(e=>e.account_survey_id==item.account_survey_id)+1}}
                    </template>
                    <template v-slot:item.set="{item}">
                        <v-btn v-if="mode==0" :to="'/question_content?m='+mode+'&s='+item.survey_id" class="ma-1" small color="success">查看</v-btn>
                        <v-btn v-if="mode==1" :to="'/question_content?m='+mode+'&s='+item.survey_id+'&d='+item.doctor_id" class="ma-1" small color="success">查看</v-btn>
                        <v-btn v-if="mode==2" :to="'/question_statistics?s='+item.survey_id" class="ma-1" small color="success">查看所有</v-btn>
                        <v-btn v-if="mode==2 && item.survey_type_id==2" :to="'/son_question_analysis?m=0&s='+item.survey_id" class="ma-1" small color="success">子問卷</v-btn>
                        <v-btn v-if="mode==3" :to="'/son_question_analysis?m=1&s='+item.survey_id" class="ma-1" small color="success">選擇</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="create_son_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">新增子問卷
                    <v-spacer/>
                    <v-icon @click="create_son_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-text-field label="請輸入問卷名稱" outlined></v-text-field>
                    <v-text-field label="請輸入所屬醫師姓名" outlined></v-text-field>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="create_son_dialog = false" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
var host_url = process.env.VUE_APP_HOST_URL
import bus from '../nav/bus'

export default {
    data(){
        return {
            // 0: 左邊測欄近來 1: 問卷內容的查看子問卷進來 2: 統計圖表查看全部進來
            mode: 0,
            search_text: "",
            page: 0,
            create_son_dialog: false,

            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '問卷名稱', align: 'center', value: 'title', sortable: false},
                {text: '建立時間', align: 'center', value: 'created_at', width: 200, sortable: false},
                {text: '所屬廠商', align: 'center', value: 'vendor', width: 200, sortable: false},
                {text: '所屬醫師', align: 'center', value: 'doctor', width: 200, sortable: false},
                {text: '發出數量', align: 'center', value: 'send_num', width: 80, sortable: false},
                {text: '完成數量', align: 'center', value: 'success_num', width: 80, sortable: false},
                {text: '操作', align: 'center', value: 'set', width: 100, sortable: false},
            ],
            table_data: [],
            survey_id: -1,
            account_type: -1,
        }
    },
    created(){
        // 問卷總覽點選查看子問卷
        if('m' in this.$route.query && this.$route.query.m == 1 && 's' in this.$route.query){
            this.survey_id = this.$route.query.s
            this.mode = 1
        }
        // 測欄點選統計圖表
        if('m' in this.$route.query && this.$route.query.m == 2){
            this.mode = 2
        }
        // 測欄點選交叉分析 (只能顯示母問卷)
        if('m' in this.$route.query && this.$route.query.m == 3){
            this.mode = 3
        }
        this.account_type = localStorage.getItem('account_type')
    },
    mounted(){
        if(this.mode == 0 || this.mode == 2 || this.mode == 3)
            this.get_survey()
        else
            this.get_son_survey()

    },
    methods:{
        UTC2ToLocal(date) {
            date = new Date(date)
            var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
            var offset = date.getTimezoneOffset() / 60;
            var hours = date.getHours();
            newDate.setHours(hours - offset);

            if(newDate.getMinutes()<10 && newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getMinutes()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":0"+newDate.getMinutes()
            else if(newDate.getHours()<10)
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" 0"+newDate.getHours()+":"+newDate.getMinutes()
            else
                newDate = newDate.getFullYear()+"-"+String(Number(newDate.getMonth()+1))+"-"+newDate.getDate()+" "+newDate.getHours()+":"+newDate.getMinutes()

            return newDate
        },
        get_survey(){
            let post_data = {mode: this.mode}
            axios.post(host_url+'get_survey_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.table_data
                }
                else{
                    bus.$emit('alert', {msg: '抓取問卷失敗！', title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
        get_son_survey(){
            let post_data = {survey_id: this.survey_id}
            axios.post(host_url+'get_son_survey_list/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.table_data
                    console.log(this.table_data)
                }
                else{
                    bus.$emit('alert', {msg: '抓取問卷失敗！', title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
    }
}
</script>
